var map = {
	"./table-buildings.svg": "b259",
	"./table-companies.svg": "7e46",
	"./table-employees.svg": "aac5",
	"./table-title-buildings.svg": "cb29",
	"./table-title-companies.svg": "eef4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f387";